import type {Tags} from '../lib/osm';
import type {POI, POIWithKind} from '../poi';
import {linksOfCommon, imagesOfCommon, includesTag, hasTag, pickTags} from '.';

enum Kind {
    DISUSED,
    ABANDONED,
}

const STYLES: {[key in Kind]: {[key: string]: string}} = {
    [Kind.DISUSED]: {color: '#ff8000'},
    [Kind.ABANDONED]: {color: '#ff0000'},
};

function styleFor(poi: POIWithKind): {[key: string]: string} {
    let style = STYLES[poi.kind as Kind];
    if(poi.tags.access && poi.tags.access != 'yes')
        style = {...style, color: `${style.color}40`};
    return style;
}

function match(tags: Tags): Kind | undefined {
    if(hasTag(tags.building)) {
        if(hasTag(tags.disused))
            return Kind.DISUSED;
        if(hasTag(tags.abandoned))
            return Kind.ABANDONED;
    }
    if(hasTag(tags['disused:building']))
        return Kind.DISUSED;
    if(hasTag(tags['abandoned:building']))
        return Kind.ABANDONED;
}

function tagsOf(poi: POI): Tags {
    const tags = poi.tags;
    const result: Tags = {};

    pickTags(result, poi, 'building', 'disused:building', 'abandoned:building');
    if(tags.access && tags.access != 'yes')
        result.access = tags.access;
    pickTags(result, poi, 'note', 'fixme');
    return result;
}

export {Kind, styleFor, match, linksOfCommon as linksOf, imagesOfCommon as imagesOf, tagsOf};
